
import { defineComponent } from 'vue'
import { store } from '../shared/store.js'

export default defineComponent({
name: 'ClinicCard',
props: ['title', 'patient'],
data: () => ({
    store,
    currentDate: new Date(),
    items: [
      {
        id: 1,
        color: 'info',
        icon: 'mdi-information',
        time: '09:00',
        patient: {
          name: "Strawberry Shortcake Jamz",
          gender: "Female",
          age: "32",
          problemSummary: "Hypertension, Diabetes, Asthma"
        }
      },
      {
        id: 2,
        color: "jamzcare",
        icon: 'mdi-information',
        time: '09:30',
        patient: {
          name: "",
          gender: "Male",
          age: "35",
          problemSummary:""
        }
      },
      {
        id: 3,
        color: "jamzcare",
        icon: 'mdi-information',
        time: '10:00',
        patient: {
          name: "Butter Cookie Jamz",
          gender: "Male",
          age: "35",
          problemSummary: "Asthma, requires constant attention"
        }
      },
      {
        id: 4,
        color: "jamzcare",
        icon: 'mdi-information',
        time: '10:30',
        patient: {
          name: "Pleach Blush Jamz",
          gender: "Male",
          age: "34",
          problemSummary: "Amnesia, Vital signs inconsistent"
        }
      },
      {
        id: 5,
        color: "jamzcare",
        icon: 'mdi-information',
        time: '11:00',
        patient: {
          name: "",
          gender: "Male",
          age: "34",
          problemSummary: ""
        }
      },
      {
        id: 6,
        color: "jamzcare",
        icon: 'mdi-information',
        time: '11:30',
        patient: {
          name: "",
          gender: "Male",
          age: "34",
          problemSummary: ""
        }
      },
      {
        id: 7,
        color: "jamzcare",
        icon: 'mdi-information',
        time: '12:00',
        patient: {
          name: "",
          gender: "Male",
          age: "34",
          problemSummary: ""
        }
      },
    ],
  }),
})
